import React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <section className="flex flex-col items-center bg-[#f5f0b5] text-black min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-4xl my-[1rem] p-6 md:p-10">
        <h2 className="text-3xl font-semibold mb-6">Privacy Policy</h2>

        <div className="text-left space-y-6 text-justify text-sm md:text-base leading-relaxed">
          <p>
            <strong>Maysam’s Privacy Policy</strong>
          </p>

          <p>
            This Privacy Policy describes how your personal information is
            collected, used, and shared when you visit or make a purchase from{" "}
            <strong>meerajaipur.com</strong>.
          </p>

          <h3 className="text-xl font-semibold">Personal Information We Collect</h3>

          <p>
            When you visit the Site, we automatically collect certain information
            about your device, including information about your web browser, IP
            address, time zone, and some of the cookies that are installed on your
            device. Additionally, as you browse the Site, we collect information
            about the individual web pages or products that you view, what
            websites or search terms referred you to the Site, and information
            about how you interact with the Site. We refer to this automatically
            collected information as <strong>“Device Information.”</strong>
          </p>

          <p>We collect Device Information using the following technologies:</p>

          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Cookies</strong> are data files that are placed on your
              device or computer and often include an anonymous unique
              identifier. For more information about cookies and how to disable
              them, visit{" "}
              <a
                href="http://www.allaboutcookies.org"
                className="text-blue-600 underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                allaboutcookies.org
              </a>.
            </li>
            <li>
              <strong>Log files</strong> track actions occurring on the Site and
              collect data including your IP address, browser type, Internet
              service provider, referring/exit pages, and date/time stamps.
            </li>
            <li>
              <strong>Web beacons, tags, and pixels</strong> are electronic files
              used to record information about how you browse the Site.
            </li>
          </ul>

          <p>
            Additionally, when you make a purchase or attempt to make a purchase
            through the Site, we collect certain information from you, including
            your name, billing address, shipping address, payment information
            (including credit card numbers), email address, and phone number. We
            refer to this information as <strong>“Order Information.”</strong>
          </p>

          <p>
            When we talk about <strong>“Personal Information”</strong> in this
            Privacy Policy, we are talking both about Device Information and
            Order Information.
          </p>

          <h3 className="text-xl font-semibold">
            How Do We Use Your Personal Information?
          </h3>

          <p>
            We use the Order Information that we collect generally to fulfill any
            orders placed through the Site (including processing your payment
            information, arranging for shipping, and providing you with invoices
            and/or order confirmations).
          </p>

          <ul className="list-disc pl-6 space-y-2">
            <li>Communicate with you</li>
            <li>Screen our orders for potential risk or fraud</li>
            <li>
              Provide you with information or advertising relating to our
              products or services, in line with your preferences
            </li>
          </ul>

          <p>
            We use the Device Information to help us screen for potential risk
            and fraud (in particular, your IP address), and more generally to
            improve and optimize our Site.
          </p>

          <h3 className="text-xl font-semibold">
            Sharing Your Personal Information
          </h3>

          <p>
            We share your Personal Information with third parties to help us use
            your Personal Information, as described above. For example, we use
            Shopify to power our online store. You can read more about how
            Shopify uses your Personal Information{" "}
            <a
              href="https://www.shopify.com/legal/privacy"
              className="text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>.
          </p>

          <p>
            We also use Google Analytics to help us understand how our customers
            use the Site. You can read more about how Google uses your Personal
            Information{" "}
            <a
              href="https://www.google.com/intl/en/policies/privacy/"
              className="text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{" "}
            and opt out{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              className="text-blue-600 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>.
          </p>

          <h3 className="text-xl font-semibold">Behavioural Advertising</h3>

          <p>
            We use your Personal Information to provide you with targeted
            advertisements or marketing communications we believe may be of
            interest to you.
          </p>

          <ul className="list-disc pl-6 space-y-2">
            <li>
              <a
                href="https://www.facebook.com/settings/?tab=ads"
                className="text-blue-600 underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.google.com/settings/ads/anonymous"
                className="text-blue-600 underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google
              </a>
            </li>
            <li>
              <a
                href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
                className="text-blue-600 underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bing
              </a>
            </li>
          </ul>

          <h3 className="text-xl font-semibold">Your Rights</h3>

          <p>
            If you are a European resident, you have the right to access personal
            information we hold about you and to ask that your personal
            information be corrected, updated, or deleted.
          </p>

          <h3 className="text-xl font-semibold">Contact Us</h3>

          <p>
            For more information about our privacy practices, if you have
            questions, or if you would like to make a complaint, please contact
            us by e-mail at{" "}
            <a
              href="mailto:maysam_india@gmail.com"
              className="text-blue-600 underline"
            >
              maysam_india@gmail.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
